export default 'salesApp';
